import React from 'react';

import styled from '@emotion/styled';

import GreenCheckBadgeIcon from '../../../components/Icons/GreenCheckBadgeIcon';

const ForgotPasswordNotification = () => {
  return (
    <Container>
      <FormWrapper>
        <HeaderSection>
          <GreenCheckBadgeIcon />
          <HeaderText>
            <div className='title'>Password Reset</div>
            <div className='description'>
              Your password reset link has been sent to your email.
            </div>
          </HeaderText>
        </HeaderSection>
      </FormWrapper>
    </Container>
  );
};

export default ForgotPasswordNotification;

const Container = styled.div`
  display: flex;
  height: 100vh;
  color: ${({ theme }) => theme.palette.grayTextColor};
  /* background-color: red; */
  background-color: ${({ theme }) => theme.palette.pageBgColor};
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 596px;
  align-self: center;
  gap: 24px;
  margin: auto;
`;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
`;

const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  text-align: center;
  margin-bottom: 4px;

  & > .title {
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    color: ${({ theme }) => theme.palette.logirateBlack};
  }

  & > .description {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
  }
`;
